<button
  class="hx-icon-picker__trigger"
  hxButton
  type="button"
  variant="outline"
  [attr.aria-label]="ariaLabel() || 'Select icon'"
  [disabled]="disabledState()"
  (click)="openPicker()">
  <span class="hx-icon-picker__icon">
    <hx-icon [svgIcon]="displayIcon()" />
  </span>
  @if (showLabel()) {
    <span class="hx-icon-picker__label">{{ displayLabel() }}</span>
  }
</button>
